export default __webpack_public_path__ + "static/media/play-button.0a621866.gif";